export const UITextMessages = {
  message: {
    LMS_HEADER_ONE:
      "There are two ways to integrate the downloaded interaction packages.",
    LMS_HEADER_SECOND:
      "Most of the LMS accept the package directly without any manual interventions. Please try uploading the package in your LMS to check this first.",
    LMS_STEPS_FIRST_H1: "Follow the below steps:",
    LMS_STEPS_FIRST_H3:
      "LMS user can directly upload Raptivity package in LMS and wait for the upload confirmation.",
    LMS_STEPS_FIRST_FORMAT: "Format: .zip file",
    LMS_STEPS_FIRST_EXAMPLE:
      "Example: Please find below few Raptivity package of different interaction",
    LMS_STEPS_FIRST_SPAN: ["1: Videogenic.zip ", " 2: OpenBookChallenge.ZIP"],
    LMS_STEPS_SECOND_H2:
      "For few LMS systems, the method of uploading is slightly different. It is achieved by the below steps.",
    LMS_STEPS_SECOND_H3:
      "LMS User needs to extract all files from below folder.",
    LMS_STEP_SECOND_FORMAT: " Format: .zip file",
    LMS_STEP_SECOND_EXAMPLE:
      "Example: Please find below few Raptivity package of different interaction",
    LMS_STEPS_SECOND_SPAN: ["1: Videogenic.zip", " 2: OpenBookChallenge.ZIP"],
    LMS_STEP_ONE_H3:
      "Step 1: LMS user needs to traverse to last folder in which all files and folder are present. ",
    LMS_STEP_ONE_H4_MAIN: "Traverse path Format:",
    LMS_STEP_ONE_H4_SUB: `<<Download Location>>${"\\"}<<Interaction Name>>${"\\"}<<Raptivity Folder name>>${"\\"}published${"\\"}<<Raptivity Folder name>>`,
    LMS_STEP_ONE_EXAMPLE: "Traverse path Example:",
    LMS_STEP_ONE_SPAN: [
      `1. C:${"\\"}WindowsUser${"\\"}Downloads${"\\"}Videogenic${"\\"}eZ8Pv${"\\"}published${"\\"}aAPjO`,

      `2. D:${"\\"}MacUser${"\\"}Downloads${"\\"}Cheese Quest -time xapi${"\\"}eZ8Pv${"\\"}published${"\\"}dwmMR`,

      ` 3. F:${"\\"}LinuxUser${"\\"}Downloads${"\\"}Open Book Challenge - 30sec scorm${"\\"}eZ8Pv${"\\"}published${"\\"}erRyE`,
    ],
    LMS_STEP_TWO_H3:
      "Step 2: Sample Folder Structure: Last Folder will look like this for Videogenic interaction. (Depending on interactions the list may vary).",

    LMS_STEP_THREE_H3:
      "Step 3: Now zip all the files and folders. You can rename the file if needed.",
    LMS_STEP_FOUR_H3:
      "Step 4:Now upload this zip file in LMS and your interaction will be ready.",
    LMS_FOOTER_MAIN:
      "Above are the proven steps to upload the package to most LMS. If you face any problems, feel free to write to  ",
    LMS_FOOTER_EMAIL: "support@raptivity.com",
    LMS_FOOTER_SUB: "for any further assitance. We are happy to help.",
    QUESTION_ONE: "How can I purchase a Raptivity subscription?",
    ANSWER_ONE: "You can purchase it online here",
    ANSWER_ONE_END: "END",
    FAQ_HEADER_SPAN: "Frequently Asked ",
    FAQ_HEADER_SPAN_QUESTION: "Questions",
    FAQ_DATA: [
      {
        question: "How can I purchase a Raptivity subscription?",
        answer: `You can purchase it from Subscription Details <a href=${process.env.REACT_APP_RAPTIVITY_URL}/myprofile?tab=1>here</a>. PayPal will send you an auto-generated invoice. Alternatively, if you need an invoice from us, please write to <a target='#'className='faq-emailLink' href='mailto:Support@Raptivity.com'>support@raptivity.com.</a>`,

        open: false,
      },
      {
        question: "How to import Raptivity interactions in any LMS?",
        answer: `The Raptivity interactions can be imported in any LMS systems as per the steps share <a target='_blank' href=${process.env.REACT_APP_RAPTIVITY_URL}/lms >here.</a>`,
        open: false,
      },
      {
        question:
          "What happens when my annual subscription expires? Will I still have access to my existing interactions?",
        answer:
          "Once the subscription expires your account will be disabled, and you will not be able to edit existing interactions or create new ones. Please renew your subscription to regain account access. No worries, the interactions published and/or downloaded before the subscription expiry can still be used.",
        open: false,
      },
      {
        question:
          "Can I brand interactions with custom logos and specific colors?",
        answer:
          "Yes, you can easily brand interactions with custom logos and colors.",
        open: false,
      },
      {
        question: "Which operating systems does Raptivity support?",
        answer:
          "Raptivity is a cloud-based tool. It works from desktops, laptops, and tablets (iPad, Surface Pro, and others) with Firefox, Chrome, IE Edge, and Safari browsers.",
        open: false,
      },
      {
        question: "Which tracking options does Raptivity support?",
        answer: "Raptivity output is SCORM 1.2 and xAPI compliant.",
        open: false,
      },
      {
        question: "How much do I have to pay per learner?",
        answer:
          "Nothing! The interactions you create with Raptivity can be published for royalty-free distribution to any number of learners. So, you only pay for your preferred subscription plan and you can create as many interactions as you like!",
        open: false,
      },
      {
        question: "Can I get a refund after purchasing Raptivity subscription?",
        answer:
          "We encourage you to try and evaluate our product with the free 14-day trial option before making any purchase decision. Therefore, we have no refund policy as the subscribers get sufficient time to evaluate and know the product’s usefulness.<br></br> For the convenience of our customers, the subscription is auto-renewed each month or quarter or year, based on the subscription. Still during the Initial Subscription Term if you think that the product will no longer be useful to you, then you can cancel your subscription’s auto-renewal before the next payment date. The auto-renewal option can be deactivated by logging into PayPal. However, just make sure you remember the renewal date!",
        open: false,
      },
      {
        question: "How can I cancel my Raptivity subscription?",
        answer:
          "You can cancel your Raptivity subscription from your PayPal account. <a target='#' href='https://www.raptivity.com/subscription-cancellation-steps.html'>Click here</a> to know the steps you need to follow for cancellation. Note: After cancellation, your subscription will continue to be active until your next monthly auto-renewal date. You may continue to use Raptivity until your subscription period ends.",
        open: false,
      },
      {
        question: "How do I take advantage of the bulk discount?",
        answer:
          "Raptivity offers a bulk discount of 10% for a single order of more than 5 users. The discount will be automatically calculated when you purchase the subscription online. Do note, the bulk discount will not be applicable on any special offers running during the year.",
        open: false,
      },
      {
        question: "Is there any discount for educational institutions?",
        answer:
          "Yes. Educational institutions can avail of a 25% discount on annual subscriptions. Please provide a .edu or .org email domain at the time of signing up.This discount can also be combined with the bulk discount option of 10% for a single order of more than 4 users.",
        open: false,
      },
    ],
    FEEDBACKTEXT_1: " Share a User Feedback and win a chance to get an additional month for no added cost.",
    FEEDBACKTEXT_2:"Write an email to",
    FEEDBACKTEXT_3: "support@raptivity.com",
    FEEDBACKTEXT_4: "for more details.",
    VERIFICATION_THANK_YOU_MESSAGE:
      "Please click the link in your email to verify the account and complete the registration.",
    VERIFICATION_LINK_EXPIRED: "Verification link expired",
    INTERACATION_NOT_FOUND: "No interaction found",
    VC_INTERACATION_NOT_FOUND: "No activity found",

    ACCOUNT_DEACTIVATED_MESSAGE: "Your account validity has expired",
    ENTER_EMAIL_ADDR_PASS: "Enter email address and password",
    ENTER_EMAIL_ADDRESS: "Please enter email address",
    ENTER_NAME: "Please enter your name",
    ENTER_ORGANIZATION_NAME: "Please enter your organization name",
    ENTER_VALID_NAME: "Please enter a valid username",
    YOPMAIL_NOT_ALLOWED:"Yopmail mail id not allowed",
    ENTER_VALID_ORGANIZATION_NAME: "Invalid organization name",
    ENTER_VALID_OCCUPATION: "Invalid occupation",

    ENTER_VALID_STATE: "Please select your state",
    ENTER_VALID_CITY: "Please select your city",

    INVALID_EMAIL_ADDRESS: "Invalid email address",
    ENTER_PASSWORD: "Please enter password",
    INVALID_PASSWORD: "Minimum 6 characters. Must include an alphabet",
    COPYRIGHT: `Copyright &copy; 2005-2019 Harbinger Knowledge Products Pvt. Ltd. All Rights Reserved.`,
    NO_EXPERIENCE_PRESENT: "No Experience present.",
    INTERACTION_LOADING: "Get set to build stunning learning experiences.",
    NO_INTERACTIONS: "Interactions created by you appear here",
    NO_INTERACTIONS_NOTE_PART1: "Start exploring interactions from the ",
    PAYMENT_ALERT_MESSAGE:
      "Thank you for choosing us. If you are residing in India, it is likely that you may face some payment issues due to the revised online payment rules. This is a temporary concern. Meanwhile, please write to us at support@raptivity.com for making online payment transfer using NEFT/RTGS.",

    VC_NO_INTERACTIONS: "Activities created by you appear here",
    VC_NO_INTERACTIONS_NOTE_PART1: "Start exploring activities from the ",

    NO_INTERACTIONS_NOTE_PART2: " tab in the header.",
    TWO_PASSWORDS_ENTERED_NOT_MATCHED: "Passwords do not match",
    PASSWORD_UPDATED_SUCCESSFULLY: "Password Updated Successfully",
    YOU_CAN_LOGIN_WITH_NEW_PASSWORD: "You can login with the new password.",
    UPDATED_SUCCESSFULLY: "Updated Successfully",
    ENTER_VALID_NUMBER: " Invalid number",
    THANKS_FOR_REGISTERING_WITH_US: "Thanks for registering with us.",
    PLEASE_ACCEPT_PRIVACY_POLICY: "Please accept the privacy policy",
    PLEASE_CHECK_YOUR_EMAIL_FOR_VERIFICATION:
      "Please click the link in your email to verify the account and complete the registration.",
    PROMPT_MESSAGE_TO_SAVE_PROFILE_DATA:
      "This page is asking you to confirm that you want to leave - data you have entered may not be saved.",
    BG_COLOR_NOTE: "Select a color for the interaction background.",
    VC_BG_COLOR_NOTE: "Select a color for the activity background.",
    INTERACTION_BACKGROUND: "Interaction Background",
    VC_INTERACTION_BACKGROUND: "Activity Background",
    BG_COLOR_NOTE_SLIDE_OVERLAY:
      "Select an overlay color to be used on top of the slide.",
    UPLOAD_INSTRUCTION: "Formats: .JPG, .JPEG, .PNG, .SVG, .GIF and .ICO",
    UPLOAD_INSTRUCTION_PDF: "Formats: .PDF",
    UPLOAD_INSTRUCTION_VERTICAL_PARALLAX:
      "Select an image to be used as the interaction background.",
    VC_UPLOAD_INSTRUCTION_VERTICAL_PARALLAX:
      "Select an image to be used as the activity background.",

    MASCOT_UPLOAD_INSTRUCTION:
      "Upload images of the master character in different positions / posture",
    UPLOAD_INSTRUCTION_IMPORT:
      "Do you want to import translated text into main interaction or create a copy before importing?",
    VC_UPLOAD_INSTRUCTION_IMPORT:
      "Do you want to import translated text into main activity or create a copy before importing?",

    UPLOAD_INSTRUCTION_AUDIO: "Format: .MP3",
    UPLOAD_INSTRUCTION_VIDEO: "Formats: .MP4 and .MOV",
    UPLOAD_INSTRUCTION_FONT: "Formats: .OTF, .TTF and .WOFF",
    NO_HOTSPOT: "Please add hotspot",
    NO_IMAGE: "Please add an image in Question NUMBER for the hotspot",
    MAX_HOTSPOT:
      "You have already added the maximum number of hotspots allowed.",
    CONFIGURED_LAYOUT_NOTE:
      "Only best suited configuration will be applied to portrait mode of all smart devices.",
    REMAINING_DAYS: 10,
    VIDEO__NOT_SUPPORTED_NOTE: "Your browser does not support the video tag.",
    SUPPORTED_AUDIO_EXT:
      "This format is not supported. Supported format - .MP3",
    SUPPORTED_IMAGE_EXT:
      "This format is not supported. Supported formats - .JPG, .JPEG, .PNG, .SVG, .GIF and .ICO",
    SUPPORTED_PDF_EXT: "This format is not supported. Supported format - .PDF",
    SUPPORTED_VIDEO_EXT:
      "This format is not supported. Supported formats - .MP4 and .MOV",
    SUPPORTED_CAPTION_EXT:
      "This format is not supported. Supported format - .VTT",
    SUPPORTED_TRANSCRIPT_EXT:
      "This format is not supported. Supported format - .TXT",
    COMING_SOON: "Coming Soon",
    BETA: "Beta",
    JUST_LAUNCHED: "Just Launched",
    PREMIUM_INTERACTION: "Premium Interaction, Free Now",
    PREMIUM_INTERACTION_MODAL_TITLE: "Premium Interaction",
    PREMIUM_INTERACTION_MODAL_DESC1: "Unlock ",
    PREMIUM_INTERACTION_MODAL_DESC2: " this one for only ",
    PREMIUM_INTERACTION_MODAL_DESC3:
      " and create royalty-free interactions for any number of learners!",
    PREMIUM_INTERACTION_MODAL_BUTTON: "Go Premium",
    STORAGE_SPACE_EXCEEDED: "Oops…Storage Full",
    INTERACTION_SLIDES_LIMIT:
      "You have added the maximum number of slides allowed.",
    SIMPLE_INTERACTION_SLIDES_LIMIT:
      "You have already added the maximum number of topics allowed.",
    QUESTION_OPTION_LIMIT:
      "You have already added the maximum number of options allowed.",
    INTERACTION_SLIDE_DELETED: "Slide Deleted Successfully.",
    INTERACTION_SLIDE_INFORMATION_DELETED:
      "Both Question and Information slide have been deleted.",
    INTERACTION_CARD_DELETED: "Card Deleted Successfully.",
    TOPIC_SLIDE_DELETED: "Topic Deleted Successfully.",
    INTERACTION_DELETED: "Selected interaction is deleted successfully",
    PUBLISHED: "Published",
    VERIFY_EMAIL_ADDRESS: [
      `<h3>Verify your Email Address </h3>
    You have not verified your email address. If you haven't received the verification email, please `,
      `<u>click here</u>`,
      `to regenerate it. Ensure that <a href='mailto:info@raptivity.com'>info@raptivity.com</a> is added to your address book to avoid the email
      going into spam.`,
    ],
    PREMIUM_FEATURES: [
      "Use 3D images and videos",
      "Create unlimited interactions",
      "Host and share interactions",
      "SCORM and xAPI compliant",
      "Brand interactions with custom logo and colors",
      "Access to Raptivity community",
      "<b>200GB of storage of interactions and media assets</b>",
      "<b>Valid for 1 year</b>",
      "<b>Advanced online training</b>",
      "<b>Download interactions for offline access</b>",
      "<b>Premium support (phone and email)</b>",
    ],
    VC_QUARTERLY_FEATURES: [
      "Create unlimited activities",
      "Host and share activities",
      "Brand activities with custom logo and colors",
      "Access to Raptivity community",
      "<b>50GB of storage of activities and media assets</b>",
      "<b>Valid for 3 months</b>",
      "<b>Advanced online training</b>",
    ],
    QUARTERLY_FEATURES: [
      "Use 3D images and videos",
      "Create unlimited interactions",
      "Host and share interactions",
      "SCORM and xAPI compliant",
      "Brand interactions with custom logo and colors",
      "Access to Raptivity community",
      "<b>50GB of storage of interactions and media assets</b>",
      "<b>Valid for 3 months</b>",
      "<b>Advanced online training</b>",
      "<b>Download interactions for offline access</b>",
      "<b>Premium support (phone and email)</b>",
    ],
    VC_PREMIUM_FEATURES: [
      "Create unlimited activities",
      "Host and share activities",
      "Brand activities with custom logo and colors",
      "Access to Raptivity community",
      "<b>200GB of storage of activities and media assets</b>",
      "<b>Valid for 1 year</b>",
      "<b>Advanced online training</b>",
    ],
    VC_FREE_FEATURES: [
      "Create unlimited activities",
      "Host and share activities",
      "Brand activities with custom logo and colors",
      "Access to Raptivity community",
      "2GB of storage of activities and media assets",
      "Valid for 14-days",
    ],
    FREE_FEATURES: [
      "Use 3D images and videos",
      "Create unlimited interactions",
      "Host and share interactions",
      "SCORM and xAPI compliant",
      "Brand interactions with custom logo and colors",
      "Access to Raptivity community",
      "2GB of storage of interactions and media assets",
      "Valid for 14-days",
    ],
    KEY_FEATURES_POINTS: [
      "Growing library of visually stunning interactions",
      "Responsive interactions",
      "Engaging micro-learning experiences",
      "SCORM and xAPI compliance",
      "Rapid customization",
    ],
    VC_KEY_FEATURES_POINTS: [
      "Growing library of visually stunning activities",
      "Responsive activities",
      "Engaging micro-learning experiences",
      "Rapid customization",
    ],
    VC_MONTHLY_FEATURES: [
      "Create unlimited activities",
      "Host and share activities",
      "Brand activities with custom logo and colors",
      "Access to Raptivity community",
      "<b>10GB of storage of activities and media assets</b>",
      "<b>Valid for 1 month</b>",
      "<b>Advanced online training</b>",
    ],
    MONTHLY_FEATURES: [
      "Use 3D images and videos",
      "Create unlimited interactions",
      "Host and share interactions",
      "SCORM and xAPI compliant",
      "Brand interactions with custom logo and colors",
      "Access to Raptivity community",
      "<b>10GB of storage of interactions and media assets</b>",
      "<b>Valid for 1 month</b>",
      "<b>Advanced online training</b>",
      "<b>Download interactions for offline access</b>",
      "<b>Premium support (phone and email)</b>",
    ],

    NO_RESULT_FOUND: "No Result Found",
    PLEASE_UPLOAD_AUDIO: "Please upload audio file",
    PLEASE_UPLOAD_FONT: "Please upload font file",
    SAVE_PROMPT_TITLE: "Please Save Changes",
    BUILDER_PROMPT_MESSAGE:
      "There are some unsaved changes detected.",
    BUILDER_PROMPT_MESSAGE_Text:"Would you like to save them or redirect anyway? ",
    NOTE_TEXT: `You may upload audio for individual slides or you may check the option 'Play Across All Slides' if you want a single audio to be played throughout this interaction. Autoplay might not be enabled by default on Safari and Chrome browsers. You may want to choose`,
    ON_CLICK_AUDIO: "On Click.",
    HAPPY_METER_NOTE_TEXT_PART_FIRST: `The selected button settings would apply to all buttons in this interaction.`,
    VC_HAPPY_METER_NOTE_TEXT_PART_FIRST: `The selected button settings would apply to all buttons in this activity.`,

    HAPPY_METER_NOTE_TEXT_PART_SECOND: `Start Assessment, Next, Submit, View Feedback And Restart Assessment`,
    HAPPY_METER_NOTE_TEXT_PART_THIRD: `buttons in this interaction.`,
    SUPPORTED_FONT_EXT:
      "This format is not supported. Supported formats - .OTF, .TTF, and .WOFF",
    SUPPORTED_PROFILE_IMG_EXT:
      "This format is not supported. Supported formats - .JPG, .JPEG and .PNG",
    HOTSPOT_POPUP_PLACEHOLDER: "Title for popup goes here",
    FILE_EXISTS: "File already exists",
    UNSAVE_PROMPT_TITLE: "Unsaved Changes Alert",
    PUBLISH_IN_PROGRESS:
      "Almost done. Your interaction will be published shortly.",
    VC_PUBLISH_IN_PROGRESS:
      "Almost done. Your activity will be published shortly.",

    SHARE_INTERACTION_SOCIAL_NETWORKS: "Share the interaction.",
    VC_SHARE_INTERACTION_SOCIAL_NETWORKS: "Share the activity.",

    INTERACTION_PUBLISHED_SUCCESSFULLY:
      "Your interaction is published successfully.",
    VC_INTERACTION_PUBLISHED_SUCCESSFULLY:
      "Awesome! Your activity is published successfully.",

    ENTER_TITLE: "Please enter title",
    GDPR_POLICY:
      "Yes, I agree that Harbinger may contact me for news, updates, marketing and sales purposes. I confirm to the processing of my Personal Data as per the terms in the",
    UPLOAD_SUCSSESS_TEXT: "File upload successful",
    ALTERNATE_TEXT_UPDATED_SUCCESSFULLY: "Alternate text updated successfully",

    UPLOAD_INPROGRESS_ALTTEXT: "Updating alt text of an Image",
    UPLOAD_INPROGRESS: "File upload in progress",
    UPLOAD_INPROGRESS_ALTTEXT: "Updating alt text of an Image",
    UPDATE_SUCCESS_ALTTEXT: "Alt text Updated successfully",
    OFFLINE_CONNECTIVITY:
      "You seem to be offline. Please check your internet connection and try again.",
    ONLINE_CONNECTIVITY: "You are now online.",
    GAMEBASED_RESULT: `What's your Happy Meter reading? Happy or Sad?`,
    COPIED: "Copied!",
    SUBSCRIBE_TO_USE_FEATURE: "Subscribe to use this feature.",
    TOPIC_SETTINGS_APPLIED_SUCCESSFULLY: "Topic Settings Applied Successfully",
    MOVE_UP: "Move Up",
    MOVE_DOWN: "Move Down",
    DELETE: "Delete",
    COPY: "Copy",
    CHANGES_SAVED: "Changes Saved",
    ERROR_SAVING_CHANGES: "Error while saving changes",
    LOGOUT_PREVIOUS_SESSION:
      "You have an active session on another browser.",
      LOGOUT_PREVIOUS_SESSION_Text:"Clicking on Ok will close the previous session. Proceed?",
   
      RESULT_MESSAGE: "Thanks all for attending & participating actively!",
    HOTSPOT: "Hotspot",
  },
  label: {
    REFERRAL_CODE_TITLE: "Invite Your Friends",
    VIDEO_LAYOUT_LABEL: "Select the layout for the question element",
    MENU_VIDEO_LABEL: "Select the settings for the video element",
    INVITE: "Invite",
    REFER_EMAIL_PLACEHOLDER:
      "Enter email id",
    REFER_NOW: "Click here & spread the joy",
    REFER_EARN_EXPERIENCE: "Refer. Earn. Experience.",
    REFER_FRIEND_CONTENT: `Recommend Raptivity to others. When they purchase any Raptivity plan, we will add an additional month to both your plan and theirs. That's our way of saying thanks!`,
    SHARE_REFERRAL: "Share on social media",
    EMAIL_CONTENT_FIRST:
      "I have been using Raptivity’s awesome eLearning interaction templates & I’m sure you’ll find them as good. Recommend you sign up for any of their affordable plans using this referral code: ",
    EMAIL_CONTENT_SECOND:
      ". This promises you an additional one-month of free subscription!",
    REFER_FRIEND: "REFER A FRIEND",
    VIRTUAL_CLASSROOM: "Virtual Classroom",
    FOR_VIRTUAL_CLASSROOM: "for Virtual Classroom",
    RAPTIVITY_2020: "Raptivity",
    RESULTS: "Results",
    VIRTUAL_CLASSROOM_SUBJECT_LINE: "Raptivity Virtual Classroom | Feedback",
    RAPTIVITY_2020_SUBJECT_LINE: "Raptivity | Feedback",
    HOW_TO_CUSTOMIZE: "How to customize",
    VIDEO_NOT_AVAILABLE: "Video not available.",
    DATE: "Date",
    RESULT_DATE: "14 Oct 2019",
    TIME_TAKEN: "Time Taken",
    TIME_TAKE_IN_SECONDS: "00:00:00",
    SCORE: "Score",
    PERCENTAGE: "Percentage",
    PERCENTAGE_IN_UMBER: "50%",
    SCORE_IN_NUMBER: "5/10",
    BONUS_POINT: "85",
    TOTAL_QUESTIONS: "36",
    ATTEMPTED: "10",
    ANSWERED: "0/5",
    ADD_ANOTHER_OPTION: "Add Another Option",
    ADD_ANOTHER_CHOICE: "Add Another Choice",
    TIME: "00:00:00",
    DELETE_THIS_OPTION: "Delete This Option",
    THIS_IS_CORRECT_OPTION: "This Is Correct Answer",
    THIS_IS_WRONG_OPTION: "Mark As Wrong Answer",
    SINGLE_CHOICE_QUESTION: "Single Response Question",
    MULTIPLE_CHOICE_QUESTION: "Multiple Response Question",
    SELECT_QUESTION_FONT: "Question Font",
    SELECT_OPTION_FONT: "Answer Option Font",
    CORRECT_ANSWER_FEEDBACK: "Correct Answer Feedback Font",
    PASS_MESSAGE: "Pass Message",
    FAIL_MESSAGE: "Fail Message",
    WRONG_ANSWER_FEEDBACK: "Incorrect Answer Feedback Font",
    TOPIC_SETTING: "Topic Setting",
    BACKGROUND_TYPE: "Select Background",
    NO_OF_TOPICS: "No. Of Topics",
    TOPIC_SHAPES: "Topic Shape",
    TOPIC_NAME: "Topic Name",
    ADD_TOPIC: "Add Topic",
    LEFT: "Left",
    RIGHT: "Right",
    TOP: "Top",
    BOTTOM: "Bottom",
    TITLE_LABEL: "Title/Label",
    INTRO_TITLE_LABEL: "Title",
    MY_WORK: "My Work",
    MY_ACTIVITY_NOTE: "My Activities List",
    WRITE_TO_US: "Write to Us",
    MY_ACCOUNT: "My Account",
    ACCOUNT_DETAILS: "Account Details",
    FLEXIBLE_PLANS_AND_PRICING: "Flexible Plans & Pricing",
    CHANGE_IMAGE: "Change Image",
    INTERACTIONS: "Interactions",
    INTERACTION_SHOWCASE: "Raptivity Interaction Showcase",
    SHOW_ALL_INTERACTIONS: "Show All",
    INTERACTIVE_DISPLAYS_INTERACTIONS: "Interactive Displays",
    GAMES_INTERACTIONS: "Games",
    QUIZZES_INTERACTIONS: "Quizzes",
    COMING_SOON_INTERACTIONS: "Coming Soon",
    FAVORITE_INTERACTIONS: "Favorites",
    ZERO_FAVOURITES: "Select your favorite interactions to be added here",
    ACTIVITIES: "Activities",
    EXPERIENCE: "Experience",
    FORGOT_PASSWORD: "Forgot Password?",
    NEW_PASSWORD: "New Password",
    CONFIRM_NEW_PASSWORD: "Confirm New Password",
    LMS_MESSAGE: "How to integrate with any LMS?",
    FAQ: "FAQs",
    AWESOME: "AWESOME!",
    PUBLISHED_LINK: "Published Link :",
    REFERRAL_CODE_TITLE: "Invite Your Friends",
    VIDEO_LAYOUT_LABEL: "Select the layout for the question element",
    MENU_VIDEO_LABEL: "Select the settings for the video element",
    INVITE: "Invite",
    REFER_EMAIL_PLACEHOLDER:
      "Enter email id",
    REFER_NOW: "Click here & spread the joy",
    REFER_EARN_EXPERIENCE: "Refer. Earn. Experience.",
    REFER_FRIEND_CONTENT: `Recommend Raptivity to others. When they purchase any Raptivity plan, we will add an additional month to both your plan and theirs. That's our way of saying thanks!`,
    SHARE_REFERRAL: "Share on social media",
    EMAIL_CONTENT_FIRST:
      "I have been using Raptivity’s awesome eLearning interaction templates & I’m sure you’ll find them as good. Recommend you sign up for any of their affordable plans using this referral code: ",
    EMAIL_CONTENT_SECOND:
      ". This promises you an additional one-month of free subscription!",
    REFER_FRIEND: "REFER A FRIEND",
    VIRTUAL_CLASSROOM: "Virtual Classroom",
    FOR_VIRTUAL_CLASSROOM: "for Virtual Classroom",
    RAPTIVITY_2020: "Raptivity",
    RESULTS: "Results",
    VIRTUAL_CLASSROOM_SUBJECT_LINE: "Raptivity Virtual Classroom | Feedback",
    RAPTIVITY_2020_SUBJECT_LINE: "Raptivity | Feedback",
    HOW_TO_CUSTOMIZE: "How to customize",
    VIDEO_NOT_AVAILABLE: "Video not available.",
    DATE: "Date",
    RESULT_DATE: "14 Oct 2019",
    TIME_TAKEN: "Time Taken",
    TIME_TAKE_IN_SECONDS: "00:00:00",
    SCORE: "Score",
    PERCENTAGE: "Percentage",
    PERCENTAGE_IN_UMBER: "50%",
    SCORE_IN_NUMBER: "5/10",
    BONUS_POINT: "85",
    TOTAL_QUESTIONS: "36",
    ATTEMPTED: "10",
    ANSWERED: "0/5",
    ADD_ANOTHER_OPTION: "Add Another Option",
    ADD_ANOTHER_CHOICE: "Add Another Choice",
    TIME: "00:00:00",
    DELETE_THIS_OPTION: "Delete This Option",
    THIS_IS_CORRECT_OPTION: "This Is Correct Answer",
    THIS_IS_WRONG_OPTION: "Mark As Wrong Answer",
    SINGLE_CHOICE_QUESTION: "Single Response Question",
    MULTIPLE_CHOICE_QUESTION: "Multiple Response Question",
    SELECT_QUESTION_FONT: "Question Font",
    SELECT_OPTION_FONT: "Answer Option Font",
    CORRECT_ANSWER_FEEDBACK: "Correct Answer Feedback Font",
    PASS_MESSAGE: "Pass Message",
    FAIL_MESSAGE: "Fail Message",
    WRONG_ANSWER_FEEDBACK: "Incorrect Answer Feedback Font",
    TOPIC_SETTING: "Topic Setting",
    BACKGROUND_TYPE: "Select Background",
    NO_OF_TOPICS: "No. Of Topics",
    TOPIC_SHAPES: "Topic Shape",
    TOPIC_NAME: "Topic Name",
    ADD_TOPIC: "Add Topic",
    LEFT: "Left",
    RIGHT: "Right",
    TOP: "Top",
    BOTTOM: "Bottom",
    TITLE_LABEL: "Title/Label",
    INTRO_TITLE_LABEL: "Title",
    MY_WORK: "My Work",
    MY_ACTIVITY_NOTE: "My Activities List",
    WRITE_TO_US: "Write to Us",
    MY_PROFILE: "My Profile",
    MY_ACCOUNT: "My Account",
    ACCOUNT_DETAILS: "Account Details",
    CHANGE_IMAGE: "Change Image",
    INTERACTIONS: "Interactions",
    INTERACTION_SHOWCASE: "Raptivity Interaction Showcase",
    SHOW_ALL_INTERACTIONS: "Show All",
    INTERACTIVE_DISPLAYS_INTERACTIONS: "Interactive Displays",
    GAMES_INTERACTIONS: "Games",
    QUIZZES_INTERACTIONS: "Quizzes",
    COMING_SOON_INTERACTIONS: "Coming Soon",
    MY_FAVORITE_INTERACTIONS: "My Favorites",
    ZERO_FAVOURITES: "Select your favorite interactions to be added here",
    ZERO_OTHER_INTERACTIONS: "No interactions found",
    ACTIVITIES: "Activities",
    EXPERIENCE: "Experience",
    FORGOT_PASSWORD: "Forgot Password?",
    NEW_PASSWORD: "New Password",
    CONFIRM_NEW_PASSWORD: "Confirm New Password",
    // ENTER_EMAIL_TO_RESET_PASSWORD: 'Enter your email address to reset your password.',
    ENTER_EMAIL_TO_RESET_PASSWORD:
      "Enter your email address associated with your account. We will send you a link to reset your password.",
    //ENTER_EMAIL_TO_RESET_PASSWORD_EMAIL: 'We will send you a link to reset your password.',
    UPDATE_PASSWORD: "Update Password",
    UPDATE_ALTTEXT: "Update",
    REGISTER: "Register",
    PREMIUMREGISTER: "Next",
    LOGIN: "Login",
    LOGOUT: "logout",
    MULTIPLE_SESSIONS: "Multiple Sessions",
    RESET_PASSWORD: "Reset Password",
    BACK_TO: "Back to",
    LOG_IN: "Log In",
    LOG_OUT: "Log Out",
    CREATE_NEW: "Create New",
    CREATE_NEW_INTERACTION: "Interactions",
    VC_CREATE_NEW_INTERACTION: "Activities",
    ENTER_BELOW_DETAILS: "Please enter below details",
    CANCEL: "Cancel",
    OK: "Ok",
    DONT_HAVE_AN_ACCOUNT: "Don't have an account?",
    ALREADY_HAVE_AN_ACCOUNT: "Already have an account?",
    CREATE_AN_ACCOUNT: "Create an Account",
    SELECT_ACCOUNT_TYPE: "Select Account Type",
    CREATE_AN_PRO_ACCOUNT: "Create a Pro Account",
    REMEMBER_ME: "Remember me",
    FACEBOOK: "Facebook",
    GOOGLE: "Google",
    PREVIEW: "Preview",
    SELECT: "Select",
    EDIT: "Edit",
    KEY_FEATURES: "Key Features",
    EULA: "EULA",
    PRIVACY_POLICY: "Privacy Policy",
    COOKIE_POLICY: "Cookie Policy",
    TERMS_OF_USE: "Terms of Use",
    SELECT_INTERACTION_GET_STARTED: "Select an interaction to get started",
    VC_SELECT_INTERACTION_GET_STARTED: "Select an activity to get started",

    EMAIL_ADDRESS: "Email Address",
    NAME_ASTERISK: "Name*",
    EMAIL_ADDRESS_ASTERISK: "Email Address*",
    PASSWORD_ASTERISK: "Password*",
    CONTACT_NUMBER: "Contact Number",
    ADDRESS: "Address",
    COUNTRY: "Country",
    STATE: "State",
    CITY: "City",
    PASSWORD: "Password",
    GOAL: "XX/YY",
    TYPE_KEYWORDS_TO_SEARCH: "Type keywords to search",
    SORT_BY: {
      A_TO_Z: "A to Z",
      MOST_FREQUENTLY_USED: "Most Frequently Used",
      LATEST_ADDITION: "Latest Addition",
    },
    SEARCH: "Search:",
    SORT_BY_TITLE: "Sort By",
    INTERACTION_BACKGROUND_COLOR: "Interaction background Color",
    VC_INTERACTION_BACKGROUND_COLOR: "Activity background Color",

    SLIDE_BACKGROUND_IMAGE: "Slide background Image",
    DESKTOP: "Desktop",
    SELECT_SLIDE: "Select Slide",
    FONT: "Font ",
    FONT_SETTINGS: "Fonts Settings",
    FONTS: "Fonts",
    SET_MINIMUM_PASSING_PERCENTAGE: "Set Minimum Passing Percentage",
    SET_MINIMUM_PASSING_PERCENTAGE_SIGN: "%",
    SHOW_RESTART_BUTTON: "Show Restart Button",
    SHOW_SCORE_IN_PERCENTAGE: "Show Percentage",
    SHOW_ATTEMPTED_QUESTION: "Show Attempted Question",
    SHOW_TIME_TAKEN: "Show Time Taken",
    SHOW_REMAINING_TIME: "Show Remaining Time",
    SHOW_QUESTION_TAB: "Show Questions",
    SHOW_INFORMATION_TAB: "Show Information",
    SHOW_COMMENTS_TAB: "Show Comments",
    SHOW_CHECK_IN_TAB: "Show Check In",
    SHOW_SURVEY_TAB: "Show Survey",
    SHOW_DATE: "Show Date",
    TIME_INTERVAL_FONT_SETTING: "Interval Font Setting",
    SELECTED_TIME_INTERVAL_FONT_STYLE: "Selected Interval Font Style ",
    SUBMIT_BUTTON: "Submit and Ok Button",
    SUBMIT: "SUBMIT",
    CREATE_ASSESSMENT: "Create Assessment",
    START_ASSESSMENT: "Start Assessment",
    RESTART_ASSESSMENT: "Restart Assessment",
    VIEW_FEEDBACK: "View Feedback",
    CONGRATULATIONS: "Congratulations!",
    THANK_YOU_ASSESSMENT:
      "Thank you for attempting vertical parallax assessment!",
    QUESTION: "QUESTION",
    RESULT: "Result",
    BUTTON_STATE: "Button Stat:",
    LISTED_TIME_INTERVAL_FONT_STYLE: "Listed Interval Font Style ",
    HOTSPOT_LIST: "Hotspot List",
    HOTSPOT_DETAILS: "Hotspot Details",
    ADD_HOTSPOT: "Add Hotspot",
    COUNT_HOTSPOT: "Count",
    HOTSPOT: "Hotspot",
    HOTSPOT_IMAGE: "Hotspot Image",
    HOTSPOT_BACKGROUND_IMAGE: "Hotspot Background Image",
    HOTSPOT_MODAL_IMAGE: "Hotspot Modal Image",
    HOTSPOT_MODAL_VIDEO: "Hotspot Modal Video",
    DELETE_HOTSPOT: "Delete Hotspot",
    BACK_TO_INTERACTION: "Back to Interaction",
    VC_BACK_TO_INTERACTION: "Back to Activity",
    UNTITLED: "Untitled",
    TITLE_FOR_HOTSPOT_MODAL: "Title for the Hotspot modal goes here",
    HOTSPOT_FONT_SETTING: "Hotspot Font Setting",
    HOTSPOT_TITLE_FONT_STYLE: "Hotspot Title Font Style",
    HOTSPOT_MODAL_TITLE_FONT_STYLE: "Hotspot Modal Title Font Style",
    HOTSPOT_MODAL_TEXT_FONT_STYLE: "Hotspot Modal Text Font Style",
    SELECT_SHAPE: "Select Shape",
    SELECT_FILL: "Select Fill",
    COLOR: "Color",
    HOSTPOT_COLOR: "Select Hotspot Color",
    BORDER_COLOR: "Border Color",
    STANDING_IMAGE: "Standing Image",
    WALKING_IMAGE: "Walking Image",
    APPLY_TO_ALL_SLIDE: "Apply to all slides",
    CONTENT_TYPE: "Content Type",
    CONTENT: "Content",
    SHARE_FEEDBACK: "Share Feedback For",
    SELECT_BACKGROUND_TYPE: "Content Type",
    SELECT_TEXT_POSITION: "Select Text Position ",
    SELECT_OVERLAY_COLOR: "Select Overlay Color ",
    SELECT_BACKGROUND_COLOR: "Select Background Color ",
    FONT_COLOR: "Font Color",
    BACKGROUND_COLOR: "Background Color",
    NORMAL_STATE: "Normal State",
    HOVER_STATE: "Hover State",
    CLICKEDSTATE: "Clicked State",
    CONFIGURE_LAYOUT: "Configure Layout",
    SELECT_INTERACTION_LAYOUT: "Select Interaction Layout",
    VC_SELECT_INTERACTION_LAYOUT: "Select Activity Layout",
    SELECT_SLIDE_CONTENT: "Select Slide Content",
    CONFIGURE_LAYOUT_TOP: "Configure Layout",
    SELECT_CONTENT_BACKGROUND: "Select Content Background",
    AUDIO_SETTING: "Audio Setting",
    APPLY: "Apply",
    IMAGE: "Image",
    TEXT: "Text",
    VIDEO: "Video",
    QUESTION: "Question",
    ALL_SLIDES: "All Slides",
    MEDIA_SORT_BY: "Sort By:",
    MEDIA_LATEST_ADDED: "Latest Added",
    MEDIA_MOST_USED: "Most Used",
    MEDIA_ASSET_LIBRARY_NOTE: "Your browser does not support the video tag.",
    CONFIGURED_LAYOUT_VIEW_IN_DIFFERENT_ORIENTATION:
      "Layout Preview for Devices and their Orientation",
    IPAD_PORTRAIT: "Tablet Portrait",
    IPAD_LANDSCAPE: "Tablet Landscape",
    MOBILE_PORTRAIT: "Mobile Portrait",
    MOBILE_LANDSCAPE: "Mobile Landscape",
    NOTE: "Note:",
    FEEDBACK_TYPE: "Feedback Type",
    SELECT_COLOR: "Select Color",
    RESET_TO_DEFAULT: "Reset to default",
    MY_LIBRARY: "My Library",
    ASSET_LIBRARY: "Asset Library",
    IMAGE_SORT_BY: "Sort By:",
    IMAGE_SORT_BY_LATEST_ADDED: "Latest Added",
    IMAGE_SORT_BY_MOST_USED: "Most Used",
    UPLOAD: "Upload",
    UPLOAD_NEW: "Upload New",
    UPLOAD_NEW_VIDEO: "Upload New Video",
    UPLOAD_NEW_IMAGE: "Upload New Image",
    UPLOAD_NEW_PDF: "Upload New PDF",
    CHANGE_ALT_TEXT: "Edit Alt Text",
    UPDATE_VIDEO_ASSET: "Upload Video Assets",
    UPLOAD_NEW_AUDIO: "Upload New Audio",
    UPLOAD_INSTRUCTION: " Upload Instruction",
    SELECT_AUDIO: "Select Audio",
    SELECT_IMAGE: "Select Image",
    IMPORT_TEXT: "Import Text from XLIFF",
    EXPORT_TEXT: "Export Text to XLIFF",
    DELETE_TEXT: "Are you sure you want to delete this interaction?",
    DELETE_INTERACTION_WORK: "Delete Interaction",
    EXPORT_INSTRUCTION: "Export interaction text as XLIFF file for translation.",
    VC_EXPORT_INSTRUCTION: "Export activity text as XLIFF file for translation",
    ACTIVITY_NOTE: "Do you want to download latest Activity Note?",
    SELECT_XLIFF: "Select Xliff",
    ALTERNATE_TEXT: "Alternate Text",
    WATERMARK_ALTERNATE_TEXT: "Raptivity2020 Watermark",
    CHOOSE_FILE: "Choose File",
    TITLE: "Title",
    INTERACTION_NAME: "Interaction Name",
    DESCRIPTION: "Description",
    LOCATION: "Location",
    LRS_SERVER_DETAILS: "LRS server details",
    SELECT_FORMAT: "Tracking format",
    SWAP_CONTENT_POSITION: "Swap Content Position",
    ADD_NEW: "Add New",
    RESET: "RESET",
    SELECT_VIDEO: "Select Video",
    CAPTION_FILE: "Caption File",
    TRANSCRIPT_FILE: "Transcript File",
    PUBLISH: "Publish",
    TRY_NOW: "Try Now",
    SHOWCASE: "Interaction Showcase",
    SHARE: "Share",
    IMPORT: "Import",
    EXPORT: "Export",
    DOWNLOAD: "Download",
    DELETE: "Delete",
    LAYOUT_1: "Layout 1",
    LAYOUT_2: "Layout 2",
    TIME_INTERVAL: "Time Interval",
    SLIDE_DEFAULT_TEXT: "",
    INTERACTION_TITLE: "Title goes here",
    TIMELINE_TITLE_PLACEHODER: "Title goes here",
    FLIPCARD_TITLE_PLACEHOLDER: "Untitled Interaction",
    FLIPCARD_QUESTION_PLACEHOLDER: "Question goes here",
    FLIPCARD_ANSWER_PLACEHOLDER: "Answer goes here",
    PLACEHOLDER_TEXT: "Description goes here",
    PASS_MESSAGE_PLACEHOLDER_TEXT:
      "Message to be displayed when learner passes the assessment",
    FAIL_MESSAGE_PLACEHOLDER_TEXT:
      "Message to be displayed when learner fails the assessment",
    CORRECT_PLACEHOLDER_TEXT: "Feedback for correct answer goes here",
    INCORRECT_PLACEHOLDER_TEXT: "Feedback for incorrect answer goes here",
    CONTENT_PLACEHOLDER_TEXT: "Content goes here",
    GAME_CONTENT_INTRO_PLACEHOLDER_TEXT: "Introduction content goes here",
    SAVE: "Save",
    IMAGE_AND_TEXT: "Title + Text",
    NO_RECENT_USED_COLORS: "No recently used colors",
    RECENT_USED_COLORS: "Recent Used Colors",
    UPLOAD_VIDEO: "Upload Video",
    ACROSS_ALL_SLIDES: "Play Across All Slides",
    NAME: "Name",
    WHEN_TO_PLAY: "When to Play",
    ACTION: "Action",
    RESULT: "Result",
    INTRODUCTION_SLIDE_REQUIRED: "Introduction Slide Required",
    PREVIOUS_NEXT_BUTTON: "PRIVIOUS & NEXT Button Required",
    PAGINATION: "PAGINATION Required",
    RESULT_SCREEN: "Result Screen Required",
    FEEDBACK_PANEL_REQUIRED: "Feedback Panel Required",
    CLOSURE_SLIDE_REQUIRED: "Closure Slide Required",
    LAYOUT_OPTIONS: "Layout Position",
    YOUTUBE_LINK: "Enter YouTube Link",
    VIMEO_LINK: "Enter Vimeo Link",
    SIZE: "Size",
    FONT_UPLOADED: "Uploaded",
    FREE_TRIAL: "Free Trial",
    PREMIUM: "Annual",
    QUARTERLY: "Quarterly",
    MONTHLY: "Monthly",
    ONEDAY: "One Day",
    SUBSCRIPTION_PLAN: "SUBSCRIPTION PLANS",
    DISTINCTIVE_INTERACTIONS: "19 distinctive interactions",
    DISTINCTIVE_COUNTING: "(& counting)",
    CURRENT_PLANS: "Current Plan",
    ANNUAL_SUBSCRIPTION: "Annual Subscription",
    QUARTERLY_SUBSCRIPTION: "Quarterly Subscription",
    MONTHLY_SUBSCRIPTION: "Monthly Subscription",
    PLANS_FEATURES1: "Use 3D Images and Videos",
    PLANS_FEATURES2: "Create Unlimited Interactions",
    PLANS_FEATURES3: "Host and Share Interactions",
    PLANS_FEATURES4: "Brand Interactions With Custom Logo and Colors",
    PLANS_FEATURES5: "Access to Raptivity Community",
    PLANS_FEATURES6: "Storage of Interactions and Media Assets",
    PLANS_FEATURES7: "Validity",
    PLANS_FEATURES8: "Download Interactions for Offline Access",
    PLANS_FEATURES9: "Premium Support (Phone and Email)",
    PLANS_FEATURES10: "Educational Institution Discount (25%)",
    PLANS_FEATURES11: "Bulk Discount (10% | 5+ users)",
    PRICING_TITLE: "Pricing",
    YOUTUBE_LINK: "Enter YouTube Link",
    SUPPORTED_FONT_EXT: 'Supported font files ".ttf" ".otf" ".woff"',
    PLAY_SETTING_FOR_ALL_AUDIOS: "Play Setting For All Audios ",
    AUDIO_SYNC_NOTE:
      "Note: This will play the video sound and the audio clip simultaneously.",
    PLAY_SETTING_FOR_AUDIO: "Play Setting For Audio ",
    SUPPORTED_FONT_EXT: 'Supported font files ".ttf" ".otf" ".woff"',
    PORTRAIT_BLOCKER_TEXT:
      "Raptivity works in the landscape mode. Please rotate your device to proceed.",
    PORTRAIT_MOB_BLOCKER_TEXT:
      "Raptivity Editor does not support mobile devices. Please use laptop or tablet for the same.",
    SELECT_BACKGROUND_TYPE: "Select Background Type",
    NONE: "None",
    DOWNLOAD: "Download",
    SAVE_CHANGES: "Save Changes",
    REDIRECT_ANYWAY: "Redirect Anyway",
    CLICK_HERE: "Click here to download the interaction",
    CLICK_HERE_PACKAGE: " package",
    TO_DOWNLOAD_INTERACTION: "to download it.",
    FREE_TRIAL_PRICE: "$0",
    PREMIUM_PRICE: "$199",
    PREMIUM_CANCELED_PRICE: "$499",
    FREE_TRIAL_DAYS: "Free trial (14 days)",
    CLOSE: "Close",
    FONT_NOTE_DESC:
      "To ensure better readibility, it is recommended to use font sizes between 11 - 28 px",
    TOPIC_NOTE_DESC:
      "Select a topic or content theme for each layer. Also choose formatting for each topic label.",
    SUBSCRIBE_NOW: "Subscribe Now",
    PUBLISH_INTERACTION: "Publish Interaction",
    VC_PUBLISH_INTERACTION: "Publish Activity",
    QUESTION_GOES_HERE: "Question goes here",
    INFORMATION_GOES_HERE: "Information goes here",
    OPTION: "Option",
    GOES_HERE: "goes here",
    QUESTION: "Question",
    BUTTON_SETTINGS: "Buttons",
    PINS_SETTING: "Pins",
    FEEDBACK_SCREEN_SETTINGS: "Feedback Screen Settings",
    RESULT_SCREEN_TAB: "Result Screen",
    BUTTON_COLOR: "Button Color",
    HORIZONTAL_PARALLAX_RES: "1920 x 768",
    PANNING_SLIDE_RES: "1920 x 768",
    LAYERD_SLIDE_RES: "1920 x 768",
    VERTICAL_PARALLAX_RES: "1920 x 6000",
    SLIDE_360_RES: "2640 x 1320",
    BACKGROUND_IMAGE: "Background Image",
    BACKGROUND_COLOR: "Background Color",
    IMMEDIATE_FEEDBACK: "Immediate Feedback",
    CUMULATIVE_FEEDBACK: "Cumutative Feedback",
    CORRECT_FEEDBACK: "Correct Answer Feedback",
    INCORRECT_FEEDBACK: "Incorrect Answer Feedback",
    PINIT_CORRECT: "Correct Answer",
    PINIT_INCORRECT: "Incorrect Answer",
    ANSWERED_BUTTON_COLOR: "Answered Button Color",
    PARKINGLOT_QUESTION_PLACEHOLDER:
      "Please plant a question you would like to discuss in class",
    OCCUPATION: "Select Occupation *",

    TYPE_OCCUPATION: "Please type occupation",
    ENTER_OCCUPATION: "Please select your occupation",
    ENTER_OTHER_OCCUPATION: "Please enter other occupation",

    ENTER_COUNTRY: "Select Country",
    SELECT_COUNTRY: "Select Country *",
    SELECT_STATE: "Select State",
    SELECT_CITY: "Select City",
    GROUP_NAME: "Group ",
    ROULETTE_SETTINGS_TAB: "Roulette Settings",
    SHOW_QUESTION: "Display Questions Next To The Roulette",
    SELECT_ROULETTE: "Select Roulette Sections",
    RIGHT_ANSWER: "Correct Answer - Button Color",
    WRONG_ANSWER: "Incorrect Answer - Button Color",
    PASS_MESSAGE_PLACEHOLDER_ROULETTE_TEXT:
      "Thanks all for attending & participating actively!",
    PASS_MESSAGE_PLACEHOLDER_PINIT_TEXT:
      "Thanks for participating in this  activity.",
    IMAGE_WIDTH_1200: "1200",
    IMAGE_WIDTH_500: "500",
    IMAGE_HEIGHT_500: "500",
    SELECT_IMAGE: "Image dimension should be",
    SELECT_IMAGE_TEXT:" 1200 X 500 or 500 X 500.",
    TAP_CONTENT: "Tap on the image where you want to place the pin",
    INFORMATION: "Information",
    SET_GOAL: "Set Goal",
    SHOW_GOAL: "Show Goal Status",
    SHOW_LEVEL: "Show Level",
    SET_POINTS: 10,
    UPDATE_USER_INFORMATION: "Below profile details are required to Preview",
    OCCUPATION_OTHER: "  Please Specify",
    OCCUPATION_REQUIRED: "Occupation is required",
    COUNTRY_REQUIRED: "Please select your country",
    UNITED_STATES :"Please try 'United States' instead.",
    CONFIRM_DELETE:
      "Are you sure you want to delete the media? Once deleted, it will not be available for any other interaction.",
    CONFIRM_CHANGE_VIDEO:
      "Are you sure you want to change the media?",
      CONFIRM_CHANGE_VIDEO_text:"Once changed, saved data will be deleted.",
    CONFIRM_DELETE_ELEMENT: "Are you sure you want to delete an element?",
    CONFIRM_DELETE_ELEMENT_TITLE: "Delete Selected Element",
    DELETE_MEDIA_TITLE: "Delete Selected Media",
    CHANGE_VIDEO_TITLE: "Change Selected Media",
    DELETE_CONFIRM_INFO_TITLE: "Successfully Deleted",
    DELETE_CONFIRM_NOTIFICATION:
      "Selected asset has been deleted. Please refresh the application before previewing the interaction.",
    OCCUPATION_INVALID: "Invalid Occupation",
    SPIN_PASS_MESSAGE_PLACEHOLDER_TEXT:
      "Share a message with the learner on reaching the goal",
    SPIN_FAIL_MESSAGE_PLACEHOLDER_TEXT:
      "Encourage the learner with a  message to achieve the game goal",
    COMMENT_PLACEHOLDER: "Instruction text goes here",
    COMMENT_DISABLED_PLACEHOLDER:
      "Encourage users to add their comments/observations here",
    LEVEL_SCREEN_TAB: "Set Levels",
    TIMER_SCREEN_TAB: "Set Timer",
    SHOW_VIEW_ANSWER: "Show View Answers",
    SHOW_SCORE_ACHIEVED: "Show Final Score",
    SHOW_SCORE: "Show Score",
    SET_LIFELINES: 3,
    SET_GOLD_COINS: 5,
    SHOW_GOLD_COIN: "Show Gold Coins",
    LIFELINE_SETTING: "Lifeline",
    FEEDBACK_ON_QUESTION: "Feedback on questions",
    NO_RETRIES: "Number of retries allowed",
    ASSESSMENT: "Assessment",
    EMAIL_LIST: "Send Response To",
    SURVEY_QUESTION_TYPE: "Select Question Type",
    ADD_ELEMENT_TIMING: "Add element duration",
    FILE_NOT_UPLOAD_NOTE:
      "Note: Please add the video before adding any element type.",
    RECOMMENDED_OCCUPATION: "View Occupation Recommendations",
    TOTAL_USAGE_COUNT: "Total Usage Count",
    FAVOURITE_COUNT: "Favourite Count",
    LAUNCH_DATE: "Launch Date",
    USED_STORAGE: "Used Storage",
    NO_OF_USER: "Number of Users",
    EXPIRY: "Expiry Date",
    SUBSCRIPTION_AND_BILLS: "Subscription Details",
    PERSONAL_INFORMATION: "Personal Information",
    TOTAL_FAVOURITES: "Favorite Interactions ",
    MY_WORK_HEADER: "My Work ",
    MY_WORK: "My Work Interactions",
    PUBLISHED_INTERACTIONS: "Published Interactions",
    ABOUT_RAPTIVITY: "About Raptivity",
    FAQ: "FAQ",
    NOTE_MANDATORY_FIELDS:
      "NOTE: Please update the mandatory <span>*</span> fields.",
    SUBSCRIBED_TRANSACTION_TYPE: "subscribed",
    RENEW_CANCELLATION:
      "Manual subscription renewal will be enabled upto 30 days before the subscription expiry date. If auto renewal is chosen the subscription will get auto renewed on the expiry date.",
    CANCEL_SUBSCRIPTION_RENEWAL:
      "the current subscription continues until the expiry date, and it will avoid any further renewals. Kindly refer the cancellation policy ",
  },
};
